var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.UiService.shouldShowNavbar()
      ? _c("header", { staticStyle: { height: "74px" } }, [
          _c(
            "div",
            {
              staticClass: "navbar affix",
              class: { "affix-disabled": _vm.shouldDisableAffix() },
              attrs: {
                id: "navbar-main",
                "data-spy": "affix",
                "data-offset-top": "500",
                role: "navigation",
              },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "Headblock d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "navbar-header Headblock01 d-flex justify-content-between align-items-center",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _vm.shop
                              ? _c("div", { staticClass: "logoPic" }, [
                                  _vm.shop.Logo
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "logoImgBlock",
                                          attrs: {
                                            title:
                                              "Accueil - " +
                                              _vm.shop.DefaultName,
                                            href: _vm.shop.ShopId,
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "img-circle",
                                            attrs: {
                                              width: "125",
                                              height: "125",
                                              src: _vm.UrlService.imagePath(
                                                _vm.shop.ShopId,
                                                _vm.shop.Logo
                                              ),
                                              alt: _vm.shop.DefaultName,
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: {
                                        title:
                                          "Accueil - " + _vm.shop.DefaultName,
                                        href: _vm.shop.ShopId,
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.shop.DefaultName)),
                                      ]),
                                      _vm._v(" "),
                                      _vm.shop.DefaultDescription
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "restSub text-truncate",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.shop.DefaultDescription
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.shop &&
                            _vm.shop.productTree &&
                            !_vm.shop.info.display.hideOrderButtons
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "carteMenu",
                                    attrs: { id: "menu-toggle" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.UrlService.includes("landing")
                                          ? _vm.UrlService.go({
                                              name: "carte",
                                              params: {
                                                tid: 0,
                                                ShopId: _vm.shop.ShopId,
                                              },
                                            })
                                          : _vm.UiService.toggleSidebar()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-eatselfapp_menu-card",
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.shop.productTree.product.dn)
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "Headblock02" }, [
                      _vm.shop
                        ? _c("ul", [
                            _c("li", { staticClass: "openClose" }, [
                              !_vm.ShopService.isOpen()
                                ? _c("div", { staticClass: "closeStatus" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.shop.ShopId +
                                            "/accueil#horaires",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-circle",
                                        }),
                                        _c("span", [_vm._v("Fermé")]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ShopService.isOpen()
                                ? _c("div", { staticClass: "openStatus" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.shop.ShopId +
                                            "/accueil#horaires",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-circle",
                                        }),
                                        _c("span", [_vm._v("Ouvert")]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "phoneCompany" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "tel:" + _vm.getDiallable(_vm.shop.Tel),
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-eatselfapp_smartphone",
                                  }),
                                  _c("span", [_vm._v(_vm._s(_vm.shop.Tel))]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.shop.reservation
                              ? _c("li", { staticClass: "bookingPlace" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "cursor-pointer",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.UiService.showReservationModal()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-eatselfapp_calendar",
                                      }),
                                      _c("span", [_vm._v("Réserver")]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("li", { staticClass: "countryCompany" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.showGroupList()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-eatselfapp_map-pin",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.shop.City))]),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "headerRight Headblock03" }, [
                      _c("div", { staticClass: "navbar-collapse collapse" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn-group notification d-flex justify-content-between align-items-center",
                            staticStyle: { position: "static" },
                          },
                          [
                            !_vm.client
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "cursor-pointer connexion",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showClientLoginModal()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-eatselfapp_lock",
                                    }),
                                    _c("span", [_vm._v("Connexion")]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.shop && _vm.client
                              ? _c(
                                  "div",
                                  { staticClass: "btn-group userMenu" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-toggle user cursor-pointer",
                                        staticStyle: { margin: "0" },
                                        attrs: { "data-toggle": "dropdown" },
                                      },
                                      [
                                        !_vm.client.hasGravatar
                                          ? _c(
                                              "div",
                                              { staticClass: "avatarLetters" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "first" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (_vm.client.FirstName ||
                                                          "")[0]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "last" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (_vm.client.LastName ||
                                                          "")[0]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.client.hasGravatar
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "https://www.gravatar.com/avatar/" +
                                                  _vm.gravatar(
                                                    _vm.client.Email
                                                  ) +
                                                  "?s=60",
                                                alt: _vm.client.Email,
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "Fname" }, [
                                          _vm._v(_vm._s(_vm.client.FirstName)),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "icon-eatselfapp_caret",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "dropdown-menu p-0" },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "topLi bg-grey3 p-15 radius-18 mb-10",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "userName fsize-18 text-bold color-grey1 text-capitalize text-truncate mb-5",
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.client.FirstName
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.client.LastName
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "fsize-12 color-grey2 mb-15",
                                              },
                                              [_vm._v(_vm._s(_vm.client.Email))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "fsize-12 link-2",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.logout()
                                                  },
                                                },
                                              },
                                              [_vm._v("Déconnexion")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.shop.ShopId +
                                                  "/client/orders",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fie-icon_receipt",
                                              }),
                                              _c("span", [
                                                _vm._v("Mes Commandes"),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.shop.ShopId +
                                                  "/client/details",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fie-icon_fingerprint",
                                              }),
                                              _c("span", [
                                                _vm._v("Mon Compte"),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.shop.ShopId +
                                                  "/client/details",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fie-icon_pin",
                                              }),
                                              _c("span", [
                                                _vm._v("Mes Adresses"),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.shop.ShopId +
                                                  "/client/details",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fie-icon_credit-card",
                                              }),
                                              _c("span", [
                                                _vm._v("Mes Cartes"),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.client.comoMembership ||
                                        _vm.ClientService.clientFidCardForShop(
                                          _vm.client,
                                          _vm.shop
                                        )
                                          ? _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      _vm.shop.ShopId +
                                                      "/client/details#fidelite",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fie-icon_offer",
                                                  }),
                                                  _c("span", [
                                                    _vm._v("Ma fidélité"),
                                                  ]),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.shop
                              ? _c(
                                  "div",
                                  { staticClass: "btn-group cart d-flex" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn dropdown-toggle align-self-center",
                                        staticStyle: {
                                          background: "none",
                                          "box-shadow": "none",
                                        },
                                        attrs: {
                                          "data-cy": "open-cart",
                                          "data-toggle": "dropdown",
                                          disabled: !_vm.shop.canOrder,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.UiService.toggleCart()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fie-icon_takeaway2",
                                        }),
                                        _vm._v(" "),
                                        _vm.CartService.nbArticles() !== 0
                                          ? _c(
                                              "span",
                                              { staticClass: "badge" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.CartService.nbArticles()
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ShopService.prix(
                                                _vm.CartService.cartTotal()
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-group cmsMenu" }, [
      _c(
        "a",
        {
          staticClass: "cmsToggle cursor-pointer",
          attrs: { "data-target": "#modalNavigation", "data-toggle": "modal" },
        },
        [_c("i", { staticClass: "icon-eatselfapp_three-points" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }